
export { assistedSelectionPlugin } from './src/index';
